





















import Vue from 'vue';
import componentsRouter from '@/components.router';
export default Vue.extend({
  data() {
    const routes: any = componentsRouter;
    return {
      componentsList: routes[0].children,
    };
  },
});
